<template>
    <div v-if="type!=='picture'" class="row">
        <div class="col-sm-4 field-label">{{ label }}</div>
        <div class="col-sm-8 field-value form-group" >{{displayValue | formatting(type,params)}}</div>
    </div>
    <div  v-else  class="row">
        <div class="col-sm-4 field-label">{{ label }}</div>
        <div class="col-sm-8 field-value" ><ini-attachment v-if="displayValue.id"  v-bind="displayValue" /><span v-else>-</span></div>
    </div>

</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    import IniAttachment from '@/components/Attachment'
    export default {
        mixins: [formElementMixin],
        components: {
            IniAttachment
        },
        props: {
            type: {
                type:String
            },
            params:{
                type:String
            }
        }
    }
</script>
